// Envios por paqueteria · la lista desde donde se arranca o se sigue un envio.
//
// POR QUE EXISTE ESTA PANTALLA
// "Detalle de pedidos" solo muestra lo enviado HOY, y la clienta pide el envio DESPUES de
// cerrar su pedido: compra hoy en la tarde y manana pregunta si se lo mandamos. Ese pedido ya
// no aparecia por ningun lado, asi que el envio no se podia capturar. Aqui estan los pedidos
// de los ultimos dias, con buscador por nombre.
//
// Lo primero que se ve son los que ESPERAN GUIA: son los que tienen a una clienta esperando.
//
// 4-nov-2026 (dueño): los que ya tienen guia se parten segun lo que reporta Skydropx (lo pregunta
// el servidor cada 2 h): primero los que requieren atencion (naranja), luego en transito y al
// final los entregados. Antes todos decian "Ya van en camino", aunque ya se hubieran entregado.
import React from 'react';
import EnvioPaqueteria from './EnvioPaqueteria.jsx';
import { etiqueta, grupo, claseChip } from './rastreoEstados.js';
const { useState, useEffect, useCallback, useMemo } = React;

const CSS = `
.el-busca{display:flex;gap:8px;align-items:center;margin-bottom:4px}
.el-busca .c2-in{flex:1}
.el-dias{display:flex;gap:6px;margin:10px 0 2px}
.el-dias button{flex:1;padding:8px 4px;font-size:12px;border:1px solid #E2E8F0;background:#FFFFFF;color:#475569;cursor:pointer}
.el-dias button.on{border-color:#111827;color:#0F172A;font-weight:600}
.el-card{display:flex;align-items:center;gap:10px;width:100%;text-align:left;background:#FFFFFF;border:1px solid #E2E8F0;padding:12px;margin-bottom:8px;cursor:pointer}
.el-card .d{flex:1;min-width:0}
.el-card .d b{display:block;font-size:14px;line-height:1.35}
.el-card .d small{display:block;color:#64748B;font-size:12px;margin-top:2px}
.el-card .p{text-align:right;flex-shrink:0;font-size:14px;font-weight:600}
.el-chips{display:flex;flex-wrap:wrap;gap:5px;margin-top:5px}
.el-chip{font-size:11px;line-height:1.5;padding:1px 7px;border-radius:10px;white-space:nowrap;border:1px solid #CBD5E1;color:#475569;background:#F8FAFC}
.el-chip.espera{border-color:#D97706;background:#FEF3C7;color:#78350F}
.el-chip.ok{border-color:#1D8A4E;background:#E6F4EA;color:#14532D}
.el-chip.camino{border-color:#1D4ED8;background:#EFF6FF;color:#1E3A8A}
`;

const pesos = n => '$' + (Number(n) || 0).toLocaleString('es-MX', { maximumFractionDigits: 0 });
const pesos2 = n => '$' + (Number(n) || 0).toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// 22-oct-2026: un pedido SIN ticket con envío y sin lo cobrado capturado no puede mandarse a caja: va primero.
// 24-oct-2026: pagado directo a la paquetería = fuera de la caja, nunca "falta cobro".
const faltaCobro = p => !!(p.sin_ticket && p.envio && !p.envio.pagado_directo && (p.envio.cobrado_cliente === null || p.envio.cobrado_cliente === undefined));

function cuando(iso) {
  if (!iso) return '';
  const t = Date.parse(iso);
  if (!t) return '';
  // Fecha de Mexico (UTC-6 fijo, sin horario de verano), igual que el resto de la PWA.
  const hoy = new Date(Date.now() - 6 * 3600000).toISOString().slice(0, 10);
  const d = new Date(t - 6 * 3600000).toISOString().slice(0, 10);
  if (d === hoy) return 'hoy';
  const ayer = new Date(Date.now() - 6 * 3600000 - 86400000).toISOString().slice(0, 10);
  if (d === ayer) return 'ayer';
  const dias = Math.round((Date.parse(hoy) - Date.parse(d)) / 86400000);
  return 'hace ' + dias + ' días';
}

async function api(ruta) {
  const tok = localStorage.getItem('token');
  const r = await fetch(ruta, { headers: tok ? { Authorization: 'Bearer ' + tok } : {} });
  const j = await r.json().catch(() => null);
  if (!r.ok || !j || j.ok === false) throw new Error((j && j.error) || ('no se pudo (HTTP ' + r.status + ')'));
  return j;
}

export default function EnviosLista({ onCerrar }) {
  const [dias, setDias] = useState(30);
  const [q, setQ] = useState('');
  const [pedidos, setPedidos] = useState(null);
  const [err, setErr] = useState('');
  const [abierto, setAbierto] = useState(null);   // pedido completo, para la pantalla de envio
  const [abriendo, setAbriendo] = useState('');
  const [tope, setTope] = useState(null);

  const cargar = useCallback(() => {
    setErr('');
    api('/api/envios/pedidos?dias=' + dias + '&q=' + encodeURIComponent(q))
      .then(j => { setPedidos(j.pedidos || []); setTope(j.truncado ? j.total : null); })
      .catch(e => { setErr(e.message); setPedidos([]); });
  }, [dias, q]);

  // Se espera un poco al teclear para no preguntar en cada letra.
  useEffect(() => {
    const t = setTimeout(cargar, q ? 350 : 0);
    return () => clearTimeout(t);
  }, [cargar, q]);

  const [sinCobro, esperan, atencion, transito, entregados, sinEnvio] = useMemo(() => {
    const l = pedidos || [];
    const conGuia = l.filter(p => p.envio && p.envio.guia && !faltaCobro(p));
    return [
      l.filter(p => faltaCobro(p)),
      l.filter(p => p.envio && !p.envio.guia && !faltaCobro(p)),
      conGuia.filter(p => grupo(p.envio.rastreo) === 'atencion'),
      conGuia.filter(p => grupo(p.envio.rastreo) === 'transito'),
      conGuia.filter(p => grupo(p.envio.rastreo) === 'entregado'),
      l.filter(p => !p.envio),
    ];
  }, [pedidos]);
  // Chips de los pedidos sin ticket (apartados que se pagan por transferencia y se mandan): ahí lo cobrado del envío
  // entra al ticket como línea "Envío".
  const chipsTicket = p => (<>
    {p.sin_ticket && !(p.envio && p.envio.pagado_directo) && <span className="el-chip espera">{p.folio ? p.folio + ' · ' : ''}Sin ticket: el envío va en su ticket</span>}
    {p.envio && p.envio.pagado_directo
      ? <span className="el-chip ok">Envío pagado directo a la paquetería{p.envio.pagado_directo.monto != null ? ' ' + pesos2(p.envio.pagado_directo.monto) : ''}</span>
      : (p.envio && p.envio.cobrado_cliente !== null && p.envio.cobrado_cliente !== undefined && <span className="el-chip">Envío cobrado {pesos2(p.envio.cobrado_cliente)}</span>)}
  </>);
  // El chip del rastreo (lo que reporta la paqueteria), con su color.
  const chipRastreo = p => {
    const et = etiqueta(p.envio.rastreo);
    return <span className={'el-chip' + claseChip(et.tono)} data-rastreo={(p.envio.rastreo && p.envio.rastreo.estado) || ''}>{et.texto}</span>;
  };
  const chipGuia = p => <span className="el-chip ok">{p.envio.paqueteria ? p.envio.paqueteria + ' ' + p.envio.guia : 'Guía ' + p.envio.guia}</span>;
  // Las tarjetas de los que ya tienen guia: primero como va el paquete, luego la guia y lo de siempre.
  const conGuiaChips = p => (<>
    {chipRastreo(p)}
    {chipGuia(p)}
    {p.envio.espejo_invitado === false
      ? <span className="el-chip">Enlazado a su cuenta</span>
      : (p.envio.espejo_numero && <span className="el-chip">Sin cuenta enlazada</span>)}
    {chipsTicket(p)}
  </>);

  const abrir = async (p) => {
    setAbriendo(p.id); setErr('');
    try {
      const j = await api('/api/envios/' + p.id);
      setAbierto(j.pedido);
    } catch (e) { setErr('No se pudo abrir ese pedido: ' + e.message); }
    finally { setAbriendo(''); }
  };

  const tarjeta = (p, chip) => (
    <button type="button" key={p.id} className="el-card" onClick={() => abrir(p)} disabled={abriendo === p.id}>
      <span className="d">
        <b>{p.client_name}</b>
        <small>{cuando(p.sent_at)} · {p.piezas} pz{p.vendor_name ? ' · ' + p.vendor_name : ''}</small>
        <span className="el-chips">{chip}</span>
      </span>
      <span className="p">{abriendo === p.id ? '…' : pesos(p.importe)}</span>
    </button>
  );

  if (abierto) {
    return (
      <EnvioPaqueteria
        pedido={abierto}
        onCerrar={() => { setAbierto(null); cargar(); }}
        onGuardado={() => cargar()}
      />
    );
  }

  return (
    <div className="c2-sheet" role="dialog" aria-modal="true" aria-label="Envíos por paquetería">
      <style>{CSS}</style>
      <div className="c2-sh-top">
        <button type="button" className="c2-ib" aria-label="Cerrar" onClick={onCerrar}>✕</button>
        <div className="c2-sh-t">Envíos por paquetería<small>Pedidos de los últimos {dias} días</small></div>
      </div>

      <div className="c2-sh-body">
        <div className="el-busca">
          <input className="c2-in" type="search" value={q} onChange={e => setQ(e.target.value)}
            placeholder="Busca a la clienta por su nombre" aria-label="Buscar clienta" />
        </div>
        <div className="el-dias">
          {[30, 60, 120].map(d => (
            <button type="button" key={d} className={dias === d ? 'on' : ''} onClick={() => setDias(d)}>{d} días</button>
          ))}
        </div>

        {err && <div className="c2-err" role="alert">{err}</div>}
        {tope && <p style={{ fontSize: 12, color: '#78350F', background: '#FEF3C7', border: '1px solid #D97706', padding: '8px 10px', margin: '8px 0 0' }}>
          Hay {tope} pedidos en {dias} días y solo caben los 300 más nuevos. Si no ves el que buscas, escribe el nombre de la clienta arriba.
        </p>}
        {pedidos === null && !err && <div className="c2-empty sm">Cargando pedidos…</div>}

        {pedidos !== null && pedidos.length === 0 && (
          <div className="c2-empty">
            <h3>Sin pedidos</h3>
            {q ? 'Ninguna clienta con ese nombre en los últimos ' + dias + ' días.'
               : 'No hay pedidos enviados en los últimos ' + dias + ' días.'}
          </div>
        )}

        {sinCobro.length > 0 && (<>
          <div className="c3-sec-h"><span>Falta lo cobrado del envío ({sinCobro.length})</span><span>sin esto no se manda a caja</span></div>
          {sinCobro.map(p => tarjeta(p, <>
            <span className="el-chip espera">Captura cuánto se le cobró del envío</span>
            {p.envio.guia && chipRastreo(p)}
            {p.envio.guia && chipGuia(p)}
            {chipsTicket(p)}
          </>))}
        </>)}

        {esperan.length > 0 && (<>
          <div className="c3-sec-h"><span>Esperando guía ({esperan.length})</span><span>la clienta ya está esperando</span></div>
          {esperan.map(p => tarjeta(p, <><span className="el-chip espera">Falta generar la guía</span>{chipsTicket(p)}</>))}
        </>)}

        {atencion.length > 0 && (<>
          <div className="c3-sec-h"><span>Requieren atención ({atencion.length})</span><span>revisa con la paquetería</span></div>
          {atencion.map(p => tarjeta(p, conGuiaChips(p)))}
        </>)}

        {transito.length > 0 && (<>
          <div className="c3-sec-h"><span>En tránsito ({transito.length})</span></div>
          {transito.map(p => tarjeta(p, conGuiaChips(p)))}
        </>)}

        {entregados.length > 0 && (<>
          <div className="c3-sec-h"><span>Entregados ({entregados.length})</span></div>
          {entregados.map(p => tarjeta(p, conGuiaChips(p)))}
        </>)}

        {sinEnvio.length > 0 && (<>
          <div className="c3-sec-h"><span>Sin envío ({sinEnvio.length})</span><span>toca uno para mandarlo por paquetería</span></div>
          {sinEnvio.map(p => tarjeta(p, chipsTicket(p)))}
        </>)}
      </div>
    </div>
  );
}
